import "./color.scss";
import * as React from "react";

export const Colors = ({colorsTileConfig}) => ({
    label: "Colors",
    render: () => <div className="combo-chart-colors-awr">{colorsTileConfig?.render()}</div>,
});
